import React from 'react';
import PrizeCodeRedemptionWindow from './PrizeCodeRedemptionWindow';

function PrizeCodeRedemptionPage() {
  return <PrizeCodeRedemptionWindow />;
}

export default PrizeCodeRedemptionPage;
